import { useEffect, useState } from 'react';

/**
 * True when the viewport is at least `minWidth`. The single definition of
 * "desktop" for JavaScript; CSS uses the same 1024px line in theme.css.
 *
 * Every new caller is a second UI tree to maintain — prefer a media query.
 */
export default function useIsDesktop(minWidth = 1024) {
    const query = `(min-width: ${minWidth}px)`;
    const [matches, setMatches] = useState(() =>
        typeof window !== 'undefined' ? window.matchMedia(query).matches : false
    );

    useEffect(() => {
        const mq = window.matchMedia(query);
        const onChange = () => setMatches(mq.matches);
        onChange();
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}
